import { render, staticRenderFns } from "./EditPageHeader.vue?vue&type=template&id=2b677801"
import script from "./EditPageHeader.vue?vue&type=script&lang=js"
export * from "./EditPageHeader.vue?vue&type=script&lang=js"
import style0 from "./EditPageHeader.vue?vue&type=style&index=0&id=2b677801&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports